import styled from 'styled-components';
import { BLACK_60, RED_100 } from '../constants/colors';

export const SearchableDropdownWrap = styled.div`
  position: relative;
  width: 100%;
`;

export const SearchableDropdownField = styled.div<{ $hasError?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  border: ${({ $hasError }) => ($hasError ? `1px solid ${RED_100}` : 'none')};
  border-radius: 16px;
  background: var(--black-5);
  padding: 0 12px 0 16px;
`;

export const SearchableDropdownInput = styled.input`
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-size: 18px;
  line-height: 24px;
  padding: 16px 8px 16px 0;
  color: var(--font-color);

  &::placeholder {
    color: ${BLACK_60};
  }
`;

export const SearchableDropdownToggle = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  color: ${BLACK_60};

  &:hover,
  &:focus {
    outline: none;
    background: var(--black-5);
    color: var(--font-color);
  }
`;

export const SearchableDropdownArrow = styled.span<{ $open: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform: rotate(${({ $open }) => ($open ? '90deg' : '-90deg')});
  transition: transform 0.15s ease-in-out;

  svg {
    display: block;
    width: 17px;
    height: 17px;

    path {
      fill: currentColor;
    }
  }
`;

export const SearchableDropdownError = styled.div`
  margin-top: 4px;
  font-size: 12px;
  line-height: 18px;
  color: ${RED_100};
`;
